import * as Constants from './constants'

export const giaoHangListRequest = function giaoHangListRequest(formData) {
  return {
    type: Constants.GIAOHANG_LIST_REQUESTING,
    payload: formData
  }
}

export const giaoHangListSuccess = function giaoHangListSuccess(data) {
  return {
    type: Constants.GIAOHANG_LIST_SUCCESS,
    data
  }
}

export const giaoHangListError = function giaoHangListError(error) {
  return {
    type: Constants.GIAOHANG_LIST_ERROR,
    error
  }
}

export const giaoHangHistoryListRequest = function giaoHangHistoryListRequest(formData) {
  return {
    type: Constants.GIAOHANG_HISTORY_LIST_REQUESTING,
    payload: formData
  }
}

export const giaoHangHistoryListSuccess = function giaoHangHistoryListSuccess(data) {
  return {
    type: Constants.GIAOHANG_HISTORY_LIST_SUCCESS,
    data
  }
}

export const giaoHangHistoryListError = function giaoHangHistoryListError(error) {
  return {
    type: Constants.GIAOHANG_HISTORY_LIST_ERROR,
    error
  }
}

export const giaoHangDetailRequest = function giaoHangDetailRequest(formData) {
  return {
    type: Constants.GIAOHANG_DETAIL_REQUESTING,
    payload: formData
  }
}

export const giaoHangDetailSuccess = function giaoHangDetailSuccess(data) {
  return {
    type: Constants.GIAOHANG_DETAIL_SUCCESS,
    data
  }
}

export const giaoHangDetailError = function giaoHangDetailError(error) {
  return {
    type: Constants.GIAOHANG_DETAIL_ERROR,
    error
  }
}

export const giaoHangUpdateRequest = (formData, callback) => {
  return {
    type: Constants.GIAOHANG_UPDATE_REQUESTING,
    payload: formData,
    callback
  }
}

export const giaoHangUpdateSuccess = function giaoHangUpdateSuccess(response) {
  return {
    type: Constants.GIAOHANG_UPDATE_SUCCESS,
    payload: response
  }
}

export const giaoHangUpdateError = function giaoHangUpdateError(error) {
  return {
    type: Constants.GIAOHANG_UPDATE_ERROR,
    error
  }
}

export const giaohangListNvRequest = function giaohangListNvRequest (formData, callback) {  
  return {
    type: Constants.GIAOHANG_LIST_NV_REQUESTING,
    formData,
    callback
  }
}

export const giaohangListNvSuccess = function giaohangListNvSuccess (data) {  
  return {
    type: Constants.GIAOHANG_LIST_NV_SUCCESS,
    data
  }
}

export const giaohangListNvError = function giaohangListNvError (error) {  
  return {
    type: Constants.GIAOHANG_LIST_NV_ERROR,
    error
  }
}

export const giaohangExportXlsRequest = (formData, onSuccess) => {
  return {
    type: Constants.GIAOHANG_EXPORT_XLS_REQUESTING,
    payload: formData,
    onSuccess
  }
}

export const giaohangExportXlsSuccess = () => {
  return {
    type: Constants.GIAOHANG_EXPORT_XLS_SUCCESS,
  }
}

export const giaohangExportXlsError = function giaohangExportXlsError(error) {
  return {
    type: Constants.GIAOHANG_EXPORT_XLS_ERROR,
    error
  }
}



// WEBPACK FOOTER //
// ./src/views/GiaoHang/actions.js